function getContactDataSelectors(state) {
  return {
    postingContactData: state.contactData.postingContactData,
    hasPostingContactData: state.contactData.hasPostingContactData,
    loadingPostingContactData: state.contactData.loadingPostingContactData,
    errorGetPostingContactData: state.contactData.errorGetPostingContactData,
    updatedUserResponsible: state.contactData.updatedUserResponsible,
    updatingUserResponsible: state.contactData.updatingUserResponsible,
    errorUpdatingUserResponsible: state.contactData.errorUpdatingUserResponsible
  };
}

export { getContactDataSelectors };
